import { render, staticRenderFns } from "./CreateFolderGroup.vue?vue&type=template&id=b8d5f898&scoped=true"
import script from "./CreateFolderGroup.vue?vue&type=script&lang=js"
export * from "./CreateFolderGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d5f898",
  null
  
)

export default component.exports